import fetchEcomm from '../util/fetchEcomm';

/**
 * Attempts to fetch user.
 * Sends a request to server with cookies to validate against.
 * @param {Object} [options] Options to pass to fetch()
 * @returns {Promise} Always resolves. Will either resolve with
 * js object if user session, or null if no user session.
 */
export async function fetchUser(options = {}) {
  try {
    const res = await fetchEcomm('/storefront/api/users/current', options);
    const json = await res.json();
    return json;
  } catch (e) {
    return null;
  }
}

/**
 * Attempts to fetch referral info
 */
export const fetchReferralInfo = async (email) => {
  try {
    const res = await fetchEcomm(`/storefront/api/referral?email=${email}`);
    const json = await res.json();
    return json;
  } catch (e) {
    return {};
  }
};

/**
 * Fetch a list of products
 */
export const fetchProducts = async () => {
  try {
    const res = await fetchEcomm('/storefront/api/search');
    const json = await res.json();
    return json.products;
  } catch (e) {
    return {};
  }
};
